import firebase from "./firebase";
import "firebase/compat/firestore";

// Re-export the Firebase firestore namespace for type usage
export const firestore = firebase.firestore;

// Wait for app to fully initialize before configuring Firestore
const getFirestore = () => {
  try {
    // Check if user is authenticated before allowing Firestore operations
    if (!firebase.auth().currentUser) {
      console.warn("Firestore access attempted without authentication");
    }
    return firebase.firestore();
  } catch (error) {
    console.error("Error accessing Firestore:", error);
    throw error;
  }
};

// Try to enable persistence but don't block on it
setTimeout(() => {
  try {
    const db = firebase.firestore();
    db.enablePersistence({
      synchronizeTabs: true,
    }).catch((err) => {
      if (err.code === "failed-precondition") {
        console.warn("Firestore persistence failed: Multiple tabs open");
      } else if (err.code === "unimplemented") {
        console.warn("Firestore persistence not supported in this browser");
      } else {
        console.error("Firestore persistence error:", err);
      }
    });
  } catch (err) {
    console.error("Error enabling Firestore persistence:", err);
  }
}, 300); // Longer delay to ensure Firebase is fully initialized

export default getFirestore;
